module.exports = __webpack_public_path__ + "img/upload1.9db45bfb.png";